<template>
  <div class="container">
    <el-form :model="form" inline ref="refForm" :rules="rules">
      <el-form-item class="small_label" :label="$t('common.boxNo') + ':'" prop="boxNo">
        <el-input
          v-model.trim="form.boxNo"
          name="boxNo"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.orderNo') + ':'" prop="incoOrderNo">
        <el-input
          v-model.trim="form.incoOrderNo"
          name="incoOrderNo"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.lotNo') + ':'" prop="lotNo">
        <el-input
          v-model.trim="form.lotNo"
          name="lotNo"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 150px;"
          maxlength="32"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.status') + ':'" prop="status">
        <el-select
          v-model="form.status"
          clearable
          filterable
          style="width: 180px;"
          size="small"
          collapse-tags
          multiple>
          <el-option
            v-for="(item, key) in storeBoxStatus"
            :key="key"
            :label="item.explain"
            :value="item.val">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.createTime') + ':'" prop="orderDate">
        <el-date-picker
          v-model="form.orderDate"
          type="daterange"
          size="small"
          clearable
          style="width: 250px;"
          :picker-options="pickerOptions"
          :default-value="defaultTime">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="reset">{{$t('common.reset')}}</el-button>
        <el-button type="primary" size="small" @click="queryOrderRecord">
          {{$t('common.query')}}
        </el-button>
      </el-form-item>
    </el-form>
    <div class="separator"></div>
    <div class="target-container">
      <el-table
        ref="table"
        height="100%"
        border
        :data="displayData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">
        <el-table-column prop="boxNo" :label="$t('common.boxNo')"/>
        <el-table-column :label="$t('common.subNo')" width="200">
          <template slot-scope="scope">
            {{subNoVal(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column width="200" :label="$t('common.productName')">
          <template slot-scope="scope">
            {{productName(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column prop="lotNo" :label="$t('common.lotNo')"/>
        <el-table-column prop="count" :label="$t('common.count')"/>
        <el-table-column width="80" :label="$t('common.status')">
          <template slot-scope="scope">
            {{storeBoxStatusVal(scope.row.status)}}
          </template>
        </el-table-column>
        <el-table-column prop="storePosition" :label="$t('common.storePosition')">
        </el-table-column>
        <el-table-column label="binLevel">
          <template slot-scope="scope">
            {{binLevelVal(scope.row.binLevel)}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.createTime')">
          <template slot-scope="scope">
            {{formatDate(scope.row.createAt)}}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.operate')">
          <template slot-scope="scope">
            <router-link :to="'/product-storage/edit/' + scope.row.id">
              <el-button type="text" class="link" >
                {{$t('common.detail')}}
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="totalCount"
      :pageSize="perpage"
      :current-page.sync="page"
      @current-change="onChangePage"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { storeBoxStatus } from '@/utils/defines';
import { prodStorageList } from '@/api/prodStorage';
import {
  Pagination,
} from '@/components';

const defaultForm = {
  incoOrderNo: undefined,
  lotNo: undefined,
  orderDate: undefined,
  status: undefined,
  boxNo: undefined,
};
const FAIL_BIN = 8;

export default {
  name: 'ProductStorageList',
  components: {
    Pagination,
  },
  data() {
    const storeBoxStatusObj = {};
    let orderOprTypeItem;
    for (const key in storeBoxStatus) {
      if (Object.prototype.hasOwnProperty.call(storeBoxStatus, key)) {
        orderOprTypeItem = storeBoxStatus[key];
        storeBoxStatusObj[orderOprTypeItem.val] = orderOprTypeItem.explain;
      }
    }
    return {
      form: Object.assign({}, defaultForm),
      searchParams: Object.assign({}, defaultForm),
      rules: {
      },
      page: 1,
      perpage: 20,
      totalCount: 0,
      listData: [],
      storeBoxStatusObj,
      storeBoxStatus,
    };
  },
  computed: {
    displayData() {
      return this.listData;
    },
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() > moment().add(1, 'days').valueOf();
        }
      };
    },
    defaultTime() {
      return moment().subtract(1, 'months').valueOf();
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prodStorageList();
    })
  },
  methods: {
    onChangePage() {
      this.prodStorageList();
    },
    async prodStorageList() {
      try {
        const {
          incoOrderNo,
          lotNo,
          orderDate,
          status,
          boxNo,
        } = this.searchParams;
        let orderStartDate;
        let orderEndDate;
        if (orderDate && orderDate.length === 2) {
          [orderStartDate, orderEndDate] = orderDate;
        }
        const res = await prodStorageList({
          page: this.page,
          perpage: this.perpage,
          incoOrderNo: incoOrderNo || undefined,
          status: status && status.length > 0 ? JSON.stringify(status) : undefined,
          lotNo: lotNo || undefined,
          sdate: orderStartDate,
          edate: orderEndDate,
          boxNo: boxNo || undefined,
        });
        const { data } = res;
        if (data.count !== undefined) {
          this.totalCount = data.count;
        }
        this.listData = data.records;
      } catch (e) {
        // do nothing.
      }
    },
    reset() {
      this.page = 1;
      this.form = Object.assign({}, defaultForm);
      this.searchParams = Object.assign({}, defaultForm);
      this.prodStorageList();
    },
    queryOrderRecord() {
      this.page = 1;
      this.searchParams = {...this.form};
      this.prodStorageList();
    },
    subNoVal(row) {
      const {
        incoOrdersDetail,
      } = row;
      if (!incoOrdersDetail) {
        return '';
      }
      return incoOrdersDetail.subNo;
    },
    productName(row) {
      const {
        incoOrdersDetail
      } = row;
      if (incoOrdersDetail) {
        const { product } = incoOrdersDetail;
        if (!product) {
          return '';
        }
        return `${product.productName} / ${product.chipName}`;
      }
      return '';
    },
    storeBoxStatusVal(val) {
      return this.storeBoxStatusObj[val];
    },
    binLevelVal(val) {
      if (val !== FAIL_BIN) {
        return `${val}(合格品)`;
      }
      if (val === FAIL_BIN) {
        return `${FAIL_BIN}(坏品)`;
      }
      return `${val}`;
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      const isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
      if (isSameYear) {
        return updateDate.local().format('MM/DD HH:mm');
      }
      return updateDate.local().format('YYYY/MM/DD HH:mm');
    },
  },
};
</script>

<style lang="scss" scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
  .el-form {
    padding: 10px 20px 0;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .control-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    margin: 10px 20px;
  }
  .target-container {
    flex: 1;
    display: -webkit-flex;
    display: flex;
    margin: 20px 20px 0;
    height: 100%;
    overflow: auto;
  }
  .bottom-container {
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100%;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
  .small_label .el-form-item__label {
    font-size: 12px;
  }
</style>
